import { Component, Input, OnInit } from '@angular/core';
import { StorageModel } from '@bo-client/activation-management/grid-registration/model/storage.model';

@Component({
  selector: 'app-storages-summary',
  templateUrl: './storages-summary.component.html',
  styleUrls: ['../../../../../../shared/summaries/css-summary.component.scss']
})
export class StoragesSummaryComponent implements OnInit {
  @Input() storages: StorageModel[];

  constructor() {}

  ngOnInit(): void {}
}
